module.exports = __webpack_public_path__ + "static/Sprite_2-eeb463d1132a7d89874ceb8e1034b908.jpg";